import { ActionConfig, ColumnConfig } from "./types";
import { TableActions } from "./table-actions";

interface MobileCardProps<T> {
  row: T;
  columns: ColumnConfig<T>[];
  actions?: ActionConfig<T>;
  rowKey: keyof T;
}

/**
 * Card para exibição mobile de uma linha da tabela.
 * Gera automaticamente os campos baseado nas colunas configuradas.
 */
export function MobileCard<T>({
  row,
  columns,
  actions,
  rowKey,
}: MobileCardProps<T>) {
  // Filtrar colunas visíveis no mobile
  const visibleColumns = columns.filter((col) => !col.hideOnMobile);

  return (
    <div
      className="bg-[#15203c] rounded-lg p-4 space-y-3 border border-[#5d5d5d]/30"
      role="article"
      aria-label={`Item ${String(row[rowKey])}`}
    >
      {visibleColumns.map((column) => {
        const value = row[column.key as keyof T];
        const displayValue = column.render
          ? column.render(value, row, 0)
          : value != null
          ? String(value)
          : "-";

        return (
          <div key={String(column.key)} className="flex justify-between items-start">
            <span className="text-xs text-gray-400 font-medium">{column.label}</span>
            <span className="text-sm text-white text-right max-w-[60%]">
              {displayValue}
            </span>
          </div>
        );
      })}

      {actions && (
        <div className="pt-3 border-t border-[#5d5d5d]/30 flex justify-end">
          <TableActions row={row} actions={actions} />
        </div>
      )}
    </div>
  );
}
